import Vue from "vue";

export default {
  namespaced: true,
  state: {},
  mutations: {
    setTested(state, { id, value }) {
      if (id in state) {
        state[id].tested = value;
      } else {
        Vue.set(state, id, { tested: value });
      }
    },
    setGoal(state, { id, value }) {
      if (id in state) {
        state[id].goal = value;
      } else {
        Vue.set(state, id, { goal: value });
      }
    },
  },
};
